export default __webpack_public_path__ + "static/media/WhiteEmptyFlag.8d4db279.svg";